// @flow

import styled from 'styled-components';
import Modal from 'react-modal';
import type { TextAlign, Theme } from '../../../types';
import { isBrowser, zIndexMap } from '../../../helpers';

type Props = {
  align: TextAlign,
  size: 'small' | 'medium' | 'large',
};

export const overlayStyle = {
  overlay: {
    backgroundColor: 'rgba(23, 23, 23, 0.5)',
    zIndex: zIndexMap.modal,
  },
};

if (isBrowser()) {
  Modal.setAppElement('#root');
}

export const ModalContainer = styled<typeof Modal, Theme, Props>(Modal)`
  background-color: ${props => props.theme.modal.backgroundColor};
  border-radius: ${props => props.theme.modal.borderRadius};
  bottom: auto;
  left: 50%;
  max-width: 95vw;
  outline: none;
  padding: 0;
  position: absolute;
  right: auto;
  text-align: ${props => props.align};
  top: 50%;
  transform: translate(-50%, -50%);
  width: ${props => props.theme.modal.sizes[props.size]};
`;

export const ModalFlexWrapper = styled<any, Theme>('div')`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  max-height: 90vh;

  /*
  Mediaquery targets only ie10 and ie11.
  This hack is needed because on ie the modal isnt scrolling correctly.
  Remove this if ie11 suport is droped.
  */
  @media all and (-ms-high-contrast:none) {
    overflow-y: auto;
  }

  padding-bottom: 2rem;
  flex-basis: auto;
`;

export default null;
